// extracted by mini-css-extract-plugin
module.exports = {"layout":"ImageUpload_layout___7jHy","uploadSpots":"ImageUpload_uploadSpots__KmvD9","photoUploadHeadline":"ImageUpload_photoUploadHeadline__quMMP"};